import createRatingSaga from './createRatingSaga'
import editRatingSaga from './editRatingSaga'
import deleteRatingSaga from './deleteRatingSaga'
import listRatingSaga from './listRatingSaga'
import oneRatingSaga from './oneRatingSaga'
import notHappenedSaga from './notHappenedSaga'

const momentumSagas = [
    createRatingSaga(),
    editRatingSaga(),
    deleteRatingSaga(),
    listRatingSaga(),
    oneRatingSaga(),
    notHappenedSaga()
]

export default momentumSagas
